import Menu from 'antd-mobile/lib/menu';
export default Menu;



// WEBPACK FOOTER //
// ./components/menu/index.tsx